import { render, staticRenderFns } from "./extraCost.vue?vue&type=template&id=37106a21"
import script from "./extraCost.vue?vue&type=script&lang=js"
export * from "./extraCost.vue?vue&type=script&lang=js"
import style0 from "./extraCost.vue?vue&type=style&index=0&id=37106a21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports